import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {Observable, map, } from 'rxjs';
import { APIResponse } from 'src/app/shared/data-access/api-response.model';
import { environment } from 'src/environments/environment';
import {catchApiError} from "../../shared/utils/api-error";
import {encodeParam} from "../../shared/utils/query-string";

@Injectable({
  providedIn: 'root',
})
export class ContentService {
  private httpClient = inject(HttpClient);

  getAllSubjects(): Observable<APIResponse> {
    const apiUrl = `${environment.baseUrl}/catalog/subjects/list`;

    return this.httpClient.get<APIResponse>(apiUrl).pipe(
      map((response) => {
        return response
      }),
      catchApiError()
    )
  }

  getLearningObjList(subject_id: string, customcontentlayer_id: string, page: number, limit?: number, name_contains?: string, tag_id?: string, descending?: boolean): Observable<APIResponse>{
    let apiUrl = `${environment.baseUrl}/catalog/learningobjectives/list`;

    if(subject_id != undefined && subject_id !== "")
      apiUrl += `?subject_id=${encodeParam(subject_id)}`
    else if(customcontentlayer_id != undefined && customcontentlayer_id !== "")
      apiUrl += `?customcontentlayer_id=${encodeParam(customcontentlayer_id)}`
    else
      console.error('Subject ID or CCL ID is required!')
    apiUrl += `&page=${encodeParam(page)}`
    if(limit != null)
      apiUrl += `&limit=${encodeParam(limit)}`
    else
      apiUrl += `&limit=${encodeParam(25)}`
    if(name_contains != undefined && name_contains !== "")
      apiUrl += `&name_contains=${encodeParam(name_contains)}`
    if(descending != null)
      apiUrl += `&descending=${encodeParam(descending)}`

    return this.httpClient.get<APIResponse>(apiUrl).pipe(
      map((response) => {
        return response
      }),
      catchApiError()
    )
  }

  listCCLChildren(subject_id: number, customcontentlayer_id: number): Observable<APIResponse> {
    let apiUrl = `${environment.baseUrl}/catalog/customcontentlayer/list`;

    if(customcontentlayer_id != undefined && customcontentlayer_id !== -1)
      apiUrl += `?customcontentlayer_id=${encodeParam(customcontentlayer_id)}`
    else if(subject_id != undefined && subject_id !== -1)
      apiUrl += `?subject_id=${encodeParam(subject_id)}`
    else
      console.error('Subject ID or CCL ID is required!')

    return this.httpClient.get<APIResponse>(apiUrl).pipe(
      map((response) => {
        return response
      }),
      catchApiError()
    )
  }

  listProblemTemplates(learningobjective_id: number, page: number, limit?: number, name_contains?: string, tag_id?: string, descending?: boolean): Observable<APIResponse> {
    let apiUrl = `${environment.baseUrl}/catalog/problemtemplates/list`;

    if(learningobjective_id !== -1)
      apiUrl += `?learningobjective_id=${encodeParam(learningobjective_id)}`
    else
      console.error('Learning Objective ID required!')
    apiUrl += `&page=${encodeParam(page)}`
    if(limit != null)
      apiUrl += `&limit=${encodeParam(limit)}`
    if(name_contains != null && name_contains !== "")
      apiUrl += `&name_contains=${encodeParam(name_contains)}`
    if(tag_id != null && tag_id !== "")
      apiUrl += `&tag_id=${encodeParam(tag_id)}`
    if(descending != null)
      apiUrl += `&descending=${encodeParam(descending)}`

    return this.httpClient.get<APIResponse>(apiUrl).pipe(
      map((response) => {
        return response
      }),
      catchApiError()
    )
  }

  getProblemTemplatePreview(problemtemplate_id: number) {
    let apiUrl = `${environment.baseUrl}/catalog/problemtemplates/ptfull?problemtemplate_id=${encodeParam(problemtemplate_id)}`;
    return this.httpClient.get<APIResponse>(apiUrl).pipe(
      map((response) => {
        return response
      }),
      catchApiError()
    )
  }

  listByCCLs(customcontentlayer_id: number[]) {
    // TODO test this endpoint
    let apiUrl = `${environment.baseUrl}/catalog/problemtemplates/listbyccl?customcontentlayer_id=${encodeParam(customcontentlayer_id)}`;
    return this.httpClient.get<APIResponse>(apiUrl).pipe(
      map((response) => {
        return response
      }),
      catchApiError()
    )
  }
}
